<template>
  <div v-show="clipCross">
    <div class="sm-function-module-content">
      <div class="sm-function-module-sub-section">
        <label class="label-container">裁剪宽度(米) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:63%"
            type="range"
            v-model="clipWidth"
          />
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:34%; height:25px; "
            type="number"
            v-model="clipWidth"
          />
        </div>
      </div>
      <div class="sm-function-module-sub-section">
        <label class="label-container">裁剪高度(米) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:63%"
            type="range"
            v-model="clipHeight"
          />
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:34%; height:25px;"
            type="number"
            v-model="clipHeight"
          />
        </div>
      </div>
      <div class="sm-function-module-sub-section">
        <label class="label-container">绕X轴旋转(度) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            min="0"
            max="360"
            step="1"
            style="width:63%"
            type="range"
            v-model="pitch"
          />
          <input
            class="min-solider"
            min="0"
            max="360"
            step="1"
            style="width:34%; height:25px;"
            type="number"
            v-model="pitch"
          />
        </div>
      </div>
      <div class="sm-function-module-sub-section">
        <label class="label-container">绕Y轴旋转(度) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            max="360"
            min="0"
            step="1"
            style="width:63%"
            type="range"
            v-model="roll"
          />
          <input
            class="min-solider"
            max="360"
            min="0"
            step="1"
            style="width:34%; height:25px;"
            type="number"
            v-model="roll"
          />
        </div>
      </div>
      <div class="sm-function-module-sub-section">
        <label class="label-container">绕Z轴旋转(度) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            max="360"
            min="0"
            step="1"
            style="width:63%"
            type="range"
            v-model="heading"
          />
          <input
            class="min-solider"
            max="360"
            min="0"
            step="1"
            style="width:34%; height:25px;"
            type="number"
            v-model="heading"
          />
        </div>
      </div>
      <div class="sm-function-module-sub-section">
        <label class="label-container">拉伸(米) :</label>
        <div class="sm-solider-input-box">
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:63%"
            type="range"
            v-model="extrude"
          />
          <input
            class="min-solider"
            min="0"
            step="1"
            style="width:34%; height:25px;"
            type="number"
            v-model="extrude"
          />
        </div>
      </div>
      <div class="boxchild">
        <button @click="startCross" class="tbtn tbn1" type="button">
          裁剪
        </button>
        <button @click="clearCross" class="tbtn" type="button">清除</button>
      </div>
    </div>
  </div>
</template>

<script>
let screenSpaceEventHandler, dim, box, layers;
export default {
  name: 'Sm3dClipCross',
  data() {
    return {
      sharedState: window.store.state,
      index: null, //当前插入界面位置
      clipWidth: 5,
      clipHeight: 5,
      heading: 0,
      pitch: 0,
      roll: 0,
      extrude: 1,
      startClip: false,
      hasClipped: false,
      boxPosition: null,
      position: null,
      isDestroyFlag: true
    };
  },
  created() {
    let cName = this.sharedState.componentNames;
    let cShow = this.sharedState.componentShows;
    let cType = this.sharedState.componentTypes;
    this.index = cName.length;
    if (cName.length == 0) {
      cShow.push(1);
    } else {
      cShow.push(0);
    }
    cType.push('clip');
    cName.push('Cross裁剪');
  },
  computed: {
    clipCross: function() {
      return this.sharedState.componentShows[this.index];
    },
    isInitViewer: function() {
      return this.sharedState.isInitViewer;
    }
  },
  methods: {
    start() {
      this.isDestroyFlag = false; //保留效果
      for (let layer of layers) {
        layer.selectEnabled = false;
      }
      this.boxPosition = window.Cesium.Cartesian3.fromDegrees(0, 0, 0);
      dim = new window.Cesium.Cartesian3(
        this.clipWidth,
        this.clipHeight,
        this.extrude
      );
      box = window.viewer.entities.add({
        // 标识盒
        id: 'cross-clip-identify-box',
        position: this.boxPosition,
        show: false,
        box: {
          dimensions: new window.Cesium.Cartesian3(
            this.clipWidth,
            this.clipHeight,
            0.1
          ),
          fill: false,
          outline: true,
          outlineColor: window.Cesium.Color.AQUA,
          outlineWidth: 5.0
        }
      });

      screenSpaceEventHandler.setInputAction(movement => {
        if (this.startClip) {
          this.boxPosition = window.scene.pickPosition(movement.endPosition);
          let boxPosition = this.boxPosition;
          if (!boxPosition) {
            return;
          }
          box.position = boxPosition;
          let hpr = new window.Cesium.HeadingPitchRoll(
            window.Cesium.Math.toRadians(this.heading),
            window.Cesium.Math.toRadians(this.pitch),
            window.Cesium.Math.toRadians(this.roll)
          );
          let orientation = window.Cesium.Transforms.headingPitchRollQuaternion(
            boxPosition,
            hpr
          );
          box.orientation = orientation;
        }
      }, window.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      screenSpaceEventHandler.setInputAction(evt => {
        if (this.startClip) {
          this.position = window.scene.pickPosition(evt.position);
          if (!this.position) {
            return;
          }
          this.updateClip();
          this.startClip = false;
          this.hasClipped = true;
          box.show = false;
        }
      }, window.Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },
    startCross() {
      this.start();
      if (!window.viewer) {
        return;
      }
      for (let layer of layers) {
        layer.selectEnabled = false;
      }
      this.startClip = true;
      box.show = true;
    },
    clearCross() {
      this.isDestroyFlag = true; //摧毁标志，释放内存
      this.hasClipped = false;
      box && window.viewer.entities.removeById('cross-clip-identify-box');
      for (let layer of layers) {
        layer.clearCustomClipBox();
      }
    },
    updateClip() {
      for (let layer of layers) {
        layer.setCustomClipCross({
          position: this.position,
          dimensions: dim,
          heading: this.heading,
          pitch: this.pitch,
          roll: this.roll,
          extrudeDistance: Number(this.extrude)
        });
      }
    },
    init() {
      if (screenSpaceEventHandler) return;
      screenSpaceEventHandler = new window.Cesium.ScreenSpaceEventHandler(
        window.scene.canvas
      );
      layers = window.viewer.scene.layers.layerQueue;
    }
  },
  beforeDestroy() {
    if (this.isDestroyFlag && layers) {
      screenSpaceEventHandler.destroy();
      layers = undefined;
      box = undefined;
      screenSpaceEventHandler = undefined;
      dim = undefined;
    }
  },
  mounted() {
    if (this.isInitViewer && this.clipCross) {
      this.init();
    }
  },

  watch: {
    clipCross(val) {
      if (val && this.isInitViewer) {
        this.init();
      }
    },
    isInitViewer() {
      this.init();
    },
    clipWidth(val) {
      this.clipWidth = Number(val);
      let temp_width = Number(val);
      if (temp_width <= 0 || !box) {
        return;
      }
      box.box.dimensions = new window.Cesium.Cartesian3(
        this.clipWidth,
        this.clipHeight,
        0.1
      );
      dim = new window.Cesium.Cartesian3(
        temp_width,
        this.clipHeight,
        this.extrude
      );
      if (this.hasClipped) {
        this.updateClip();
      }
    },
    clipHeight(val) {
      this.clipHeight = Number(val);
      let temp_height = Number(val);
      if (temp_height <= 0 || !box) {
        return;
      }
      box.box.dimensions = new window.Cesium.Cartesian3(
        this.clipWidth,
        temp_height,
        0.1
      );
      dim = new window.Cesium.Cartesian3(
        this.clipWidth,
        temp_height,
        this.extrude
      );
      if (this.hasClipped) {
        this.updateClip();
      }
    },
    pitch(val) {
      this.pitch = Number(val);
      if (val === '' || !box) {
        return;
      }
      let pitch = Number(val);
      let hpr = new window.Cesium.HeadingPitchRoll(
        window.Cesium.Math.toRadians(this.heading),
        window.Cesium.Math.toRadians(pitch),
        window.Cesium.Math.toRadians(this.roll)
      );
      let orientation = window.Cesium.Transforms.headingPitchRollQuaternion(
        this.boxPosition,
        hpr
      );
      box.orientation = orientation;
      if (this.hasClipped) {
        this.updateClip();
      }
    },
    roll(val) {
      this.roll = Number(val);
      if (val === '' || !box) {
        return;
      }
      let roll = Number(val);
      let hpr = new window.Cesium.HeadingPitchRoll(
        window.Cesium.Math.toRadians(this.heading),
        window.Cesium.Math.toRadians(this.pitch),
        window.Cesium.Math.toRadians(roll)
      );
      let orientation = window.Cesium.Transforms.headingPitchRollQuaternion(
        this.boxPosition,
        hpr
      );
      box.orientation = orientation;
      if (this.hasClipped) {
        this.updateClip();
      }
    },
    heading(val) {
      this.heading = Number(val);
      if (val === '' || !box) {
        return;
      }
      let heading = Number(val);
      let hpr = new window.Cesium.HeadingPitchRoll(
        window.Cesium.Math.toRadians(heading),
        window.Cesium.Math.toRadians(this.pitch),
        window.Cesium.Math.toRadians(this.roll)
      );
      let orientation = window.Cesium.Transforms.headingPitchRollQuaternion(
        this.boxPosition,
        hpr
      );
      box.orientation = orientation;
      if (this.hasClipped) {
        this.updateClip();
      }
    },
    extrude(val) {
      this.extrude = Number(val);
      let temp_extrudeDistance = Number(val);
      if (temp_extrudeDistance <= 0) {
        return;
      }
      if (this.hasClipped) {
        this.updateClip();
      }
    }
  }
};
</script>
